var _PushListServiceInit_MAX_PUSH_LENGTH, _PushListServiceInit_params, _PushListServiceInit_hashGenerator;
import { __classPrivateFieldGet } from "tslib";
import { writable } from 'svelte/store';
import { HashGenerator } from '../../../util/hash/HashGenerator';
class PushListServiceInit {
    constructor() {
        _PushListServiceInit_MAX_PUSH_LENGTH.set(this, 5);
        _PushListServiceInit_params.set(this, writable([]));
        _PushListServiceInit_hashGenerator.set(this, new HashGenerator());
    }
    get params() {
        return __classPrivateFieldGet(this, _PushListServiceInit_params, "f");
    }
    push(notification) {
        const param = {
            hash: __classPrivateFieldGet(this, _PushListServiceInit_hashGenerator, "f").generate('PushList'),
            notification,
            timestamp: notification.timestamp,
        };
        __classPrivateFieldGet(this, _PushListServiceInit_params, "f").update((it) => [param, ...it].filter((e, i) => i < __classPrivateFieldGet(this, _PushListServiceInit_MAX_PUSH_LENGTH, "f")));
    }
    readAll() {
        __classPrivateFieldGet(this, _PushListServiceInit_params, "f").update((it) => {
            it.map((param) => {
                param.notification.read = true;
                return param;
            });
            return it;
        });
    }
}
_PushListServiceInit_MAX_PUSH_LENGTH = new WeakMap(), _PushListServiceInit_params = new WeakMap(), _PushListServiceInit_hashGenerator = new WeakMap();
export const PushListService = new PushListServiceInit();
